<section class="admin-chats-page">
  <div class="admin-page-head">
    <div>
      <span class="admin-badge">إدارة شات الشحات إن</span>
      <h1>كل المحادثات</h1>
      <p>
        تابع رسائل زوار ومستخدمي الموقع، افتح المحادثة، ورد عليهم من نفس تجربة الشات الموجودة في elshahat-in.
      </p>
    </div>

    <button
      type="button"
      class="admin-refresh-btn"
      (click)="loadConversations(page)"
      [disabled]="isLoading"
    >
      تحديث
    </button>
  </div>

  <div class="admin-filters-card">
    <div class="filter-group">
      <label>بحث</label>
      <input
        type="text"
        placeholder="ابحث بالاسم أو الهاتف أو الإيميل..."
        [value]="searchKeyword"
        (input)="onSearchInput($event)"
        (keyup.enter)="loadConversations(1)"
      />
    </div>

    <div class="filter-group">
      <label>الحالة</label>
      <select [value]="selectedStatus" (change)="onStatusFilterChange($event)">
        <option *ngFor="let item of statusOptions" [value]="item.value">
          {{ item.label }}
        </option>
      </select>
    </div>

    <div class="filter-group">
      <label>نوع المستخدم</label>
      <select
        [value]="selectedUserType"
        (change)="onUserTypeFilterChange($event)"
      >
        <option *ngFor="let item of userTypeOptions" [value]="item.value">
          {{ item.label }}
        </option>
      </select>
    </div>

    <div class="filter-actions">
      <button
        type="button"
        class="primary-btn"
        (click)="loadConversations(1)"
        [disabled]="isLoading"
      >
        بحث
      </button>

      <button
        type="button"
        class="secondary-btn"
        (click)="resetFilters()"
        [disabled]="isLoading"
      >
        إعادة ضبط
      </button>
    </div>
  </div>

  <div class="admin-table-card">
    <div class="table-top">
      <div>
        <h2>Inbox</h2>
        <p>إجمالي المحادثات: {{ total }}</p>
      </div>
    </div>

    <div class="chat-stats-grid">
      <div class="chat-stat-card">
        <span>كل المحادثات</span>
        <strong>{{ total }}</strong>
      </div>

      <div class="chat-stat-card open">
        <span>مفتوحة في الصفحة</span>
        <strong>{{ openCount }}</strong>
      </div>

      <div class="chat-stat-card pending">
        <span>قيد المتابعة</span>
        <strong>{{ pendingCount }}</strong>
      </div>

      <div class="chat-stat-card closed">
        <span>مغلقة</span>
        <strong>{{ closedCount }}</strong>
      </div>
    </div>

    <div class="admin-state" *ngIf="isLoading">جاري تحميل المحادثات...</div>

    <div class="admin-state error" *ngIf="!isLoading && errorMessage">
      {{ errorMessage }}
    </div>

    <div
      class="admin-state empty"
      *ngIf="!isLoading && !errorMessage && conversations.length === 0"
    >
      لا توجد محادثات حاليا
    </div>

    <div
      class="table-responsive"
      *ngIf="!isLoading && !errorMessage && conversations.length > 0"
    >
      <table class="admin-table">
        <thead>
          <tr>
            <th>المستخدم</th>
            <th>النوع</th>
            <th>الحالة</th>
            <th>آخر رسالة</th>
            <th>آخر مرسل</th>
            <th>عدد الرسائل</th>
            <th>المصدر</th>
            <th>آخر تحديث</th>
            <th>إجراءات</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let conversation of conversations">
            <td>
              <div class="chat-user-cell">
                <div
                  class="chat-avatar"
                  [class.guest]="conversation.user_type === 'guest'"
                  [class.candidate]="conversation.user_type === 'candidate'"
                  [class.company]="conversation.user_type === 'company'"
                  [class.admin]="conversation.user_type === 'admin'"
                >
                  {{ getAvatarLetter(conversation) }}
                </div>

                <div>
                  <strong>{{ getUserDisplayName(conversation) }}</strong>
                  <small>{{ getUserSubText(conversation) }}</small>
                </div>
              </div>
            </td>

            <td>
              <span
                class="type-badge"
                [class.guest]="conversation.user_type === 'guest'"
                [class.candidate]="conversation.user_type === 'candidate'"
                [class.company]="conversation.user_type === 'company'"
                [class.admin]="conversation.user_type === 'admin'"
              >
                {{ getUserTypeLabel(conversation.user_type) }}
              </span>
            </td>

            <td>
              <select
                class="status-select"
                [class.open]="conversation.status === 'open'"
                [class.pending]="conversation.status === 'pending'"
                [class.closed]="conversation.status === 'closed'"
                [value]="conversation.status"
                (change)="updateStatus(conversation, $event)"
                [disabled]="isUpdating"
              >
                <option value="open">مفتوح</option>
                <option value="pending">قيد المتابعة</option>
                <option value="closed">مغلق</option>
              </select>
            </td>

            <td>
              <p class="latest-message">
                {{ getLatestMessage(conversation) }}
              </p>
            </td>

            <td>
              <span class="sender-badge">
                <small>{{ getLatestSenderIcon(conversation) }}</small>
                {{ getLatestSenderLabel(conversation) }}
              </span>
            </td>

            <td>
              <strong>{{ conversation.messages_count || 0 }}</strong>
            </td>

            <td>
              <span class="source-page">
                {{ conversation.source_page || '-' }}
              </span>
            </td>

            <td>
              <span class="date-text">
                {{
                  formatDate(
                    conversation.last_message_at || conversation.updated_at
                  )
                }}
              </span>
            </td>

            <td>
              <div class="table-actions">
                <button
                  type="button"
                  class="edit-btn"
                  (click)="openConversation(conversation)"
                >
                  عرض المحادثة
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination" *ngIf="lastPage > 1">
      <button
        type="button"
        (click)="loadConversations(page - 1)"
        [disabled]="page === 1 || isLoading"
      >
        السابق
      </button>

      <button
        type="button"
        *ngFor="let pageNumber of getPages()"
        [class.active]="pageNumber === page"
        (click)="loadConversations(pageNumber)"
        [disabled]="isLoading"
      >
        {{ pageNumber }}
      </button>

      <button
        type="button"
        (click)="loadConversations(page + 1)"
        [disabled]="page === lastPage || isLoading"
      >
        التالي
      </button>
    </div>
  </div>
</section>
